<div class="flex">
  <sbnb-subnav class="w-[280px] hidden md:block" [header]="'OPERATIONS.OPERATIONS' | transloco">
    <sbnb-operations-subnav></sbnb-operations-subnav>
    <sbnb-helptext-wrapper [area]="'sidebar'" [pageId]="'statements-accounting-connections'"></sbnb-helptext-wrapper>
  </sbnb-subnav>

  <main class="flex-1 subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <app-feature-flag-tabs>
      <sbnb-page-header navTabs></sbnb-page-header>
    </app-feature-flag-tabs>
    <sbnb-accounting-upsell>
      <ng-container *ngIf="connectionsState$ | async as state">
        <!-- Loading state -->
        <div class="flex justify-center" *ngIf="state.loading">
          <sbnb-loading-spinner></sbnb-loading-spinner>
        </div>

        <!-- Connecting state -->
        <div class="flex justify-center items-center flex-col" *ngIf="connecting$ | async">
          <sbnb-loading-spinner></sbnb-loading-spinner>
          <h3>Connecting to your accounting software...</h3>
        </div>

        <!-- Error state -->
        <div class="text-center" *ngIf="state.error">{{ state.error }}</div>

        <!-- New Connection view -->
        <div
          class="flex-1 flex items-center justify-center p-8"
          *ngIf="!state.loading && !state.error && !state.data?.length && (connecting$ | async) === false">
          <div class="w-full max-w-6xl">
            <div>
              <div class="mb-4">
                <h1 class="text-3xl font-bold" data-tour="accounting-setup-title">Connect your accounting software</h1>
                <sbnb-helptext-wrapper
                  [area]="'intro'"
                  [pageId]="'statements-accounting-connections'"></sbnb-helptext-wrapper>
              </div>
              <div
                class="border border-smoke rounded-lg p-8 flex flex-col xl:flex-row justify-between xl:items-center bg-white shadow">
                <div class="flex-initial max-w-lg mb-4 xl:mb-0">
                  <h2 class="text-xl font-semibold mb-2">Quickbooks</h2>
                  <p>
                    Interacts with your accounts and classes to push journal entries of reservations and transactions on
                    published statements.
                  </p>
                </div>
                <sbnb-button
                  class="block"
                  label="Connect"
                  [loading]="(loadingVault$ | async) === true"
                  (clicked)="openVault()"
                  data-tour="connect-quickbooks-btn"></sbnb-button>
              </div>
            </div>
          </div>
        </div>

        <!-- Current connections view -->
        <div *ngIf="!state.loading && !state.error && state.data?.length">
          <div class="flex items-center justify-between">
            <h1>Accounting connections</h1>
            <sbnb-button
              [disabled]="true"
              label="+ Connect"
              matTooltip="Only a single accounting integration account can be connected"></sbnb-button>
          </div>
          <sbnb-helptext-wrapper
            [area]="'intro'"
            [pageId]="'statements-accounting-connections'"></sbnb-helptext-wrapper>

          <mat-table [dataSource]="state.data">
            <!-- Connection Column -->
            <ng-container matColumnDef="connection">
              <mat-header-cell mat-header-cell *matHeaderCellDef>Connection</mat-header-cell>
              <mat-cell mat-cell *matCellDef="let element">
                <div class="flex gap-2 items-center">
                  <img
                    src="/assets/images/qb-logo.svg"
                    alt="Quickbooks"
                    class="max-h-12 max-w-[160px] py-2"
                    onload="SVGInject(this)" />

                  <span class="text-night strong">{{ element.name }}</span>
                </div>
              </mat-cell>
            </ng-container>
            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <mat-header-cell mat-header-cell *matHeaderCellDef>Status</mat-header-cell>
              <mat-cell mat-cell *matCellDef="let element">
                <sbnb-badge [context]="element.enabled ? 'positive' : 'warning'">
                  {{ element.enabled ? connectionStatusLabelMap[element.state] : 'Not configured' }}
                </sbnb-badge>
              </mat-cell>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <mat-header-cell mat-header-cell *matHeaderCellDef class="max-w-12">Actions</mat-header-cell>
              <mat-cell mat-cell *matCellDef="let element" class="max-w-12">
                <!-- <sbnb-icon
                *ngIf="!(deleting$ | async)[element.id]?.inProgress && !element.enabled"
                icon="trash"
                class="text-night hover:text-rose-darker"
                (click)="deleteConnectionPrompt(element); $event.stopPropagation()"
                matTooltip="Delete connection"></sbnb-icon> -->
                <ng-container *ngIf="debugging$ | async">
                  <sbnb-icon
                    *ngIf="(loadingVault$ | async) === false"
                    icon="edit"
                    class="ml-6"
                    (click)="openVaultForConnection(element); $event.stopPropagation()"></sbnb-icon>
                </ng-container>
                <sbnb-loading-spinner
                  [size]="24"
                  *ngIf="(loadingVault$ | async) || (deleting$ | async)[element.id]?.inProgress"></sbnb-loading-spinner>
              </mat-cell>
            </ng-container>

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row
              class="hover:bg-smoke-lighter cursor-pointer"
              *matRowDef="let row; columns: displayedColumns"
              [class.disabled]="(deleting$ | async)[row.id]?.inProgress"
              [routerLink]="row.enabled ? ['./', row.id] : ['./', row.id, 'new']"></mat-row>
          </mat-table>
        </div>
      </ng-container>
    </sbnb-accounting-upsell>
  </main>
</div>
<sbnb-mobile-sidebar [navTabsHide]="true" [title]="'Operations'">
  <sbnb-operations-subnav></sbnb-operations-subnav>
</sbnb-mobile-sidebar>
